import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Loading from "components/Loading/Loading";
import { Empty } from "shared/Notifications/Error";
import Table from "components/Table/Table";
import {
  deleteAllOrdersAction,
  getAllOrdersAction,
  resetOrderState,
} from "../../redux/features/orderSlide";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import SidebarMenu from "containers/UserDashboard/SideBarMenu";
import AOS from "aos"; // make sure it's imported here
import bookingApi from "api/booking/BookingApi";
import TableBooking from "components/Table/TableBooking";

const ListingBooking = () => {
  const dispatch = useDispatch();

  const [bookings, setBookings] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  // Fetch bookings from API
  useEffect(() => {
    const fetchBookings = async () => {
      setLoading(true);
      const { response, err } = await bookingApi.getAllBookings();

      if (response) {
        const data = response.data;

        if (Array.isArray(data.booking)) {
          setBookings(data.booking); // ✅ this is the array you need
        } else {
          console.error("Unexpected bookings format:", data);
          setBookings([]);
          setError("Unexpected data format from API");
        }
      } else {
        console.error("Error fetching bookings:", err);
        setError("Failed to load bookings");
      }

      setLoading(false);
    };

    fetchBookings();
  }, []);

  console.log({ bookings });

  // const deleteAllOrdersHandler = () => {
  //   if (window.confirm("All booking will be deleted")) {
  //     dispatch(deleteAllOrdersAction());
  //   }
  // };

  useEffect(() => {
    if (!loading) {
      setTimeout(() => {
        AOS.refreshHard(); // ← use refreshHard instead of refresh
      }, 50); // delay ensures DOM is painted
    }
  }, [loading]);
  return (
    <div className="bg-gray-900 text-white min-h-screen pb-8 pt-12 px-4">
      <div className="container mx-auto px-2">
        <div className="xl:grid grid-cols-8 gap-10 items-start md:py-12 py-6">
          {/* Sidebar */}
          <div className="hidden md:block sticky col-span-2 bg-gray-800 p-6 rounded-md xl:mb-0 mb-5">
            <SidebarMenu />
          </div>

          {/* Main Content */}
          {loading ? (
            <div className="flex-colo h-96 col-span-6">
              <Loading />
            </div>
          ) : (
            <div
              data-aos="fade-up"
              key={loading ? "loading" : "loaded"}
              className="col-span-6 rounded-md bg-gray-800 p-6"
            >
              <div className="flex flex-col gap-4">
                <div className="flex justify-between items-center gap-2">
                  <h2 className="text-xl font-bold">Booking History</h2>
                  {bookings.length > 0 && (
                    <ButtonPrimary
                      onClick={() => {
                        if (window.confirm("All bookings will be deleted")) {
                          // You can later wire this with `bookingApi.deleteAllBookings()`
                        }
                      }}
                      className="bg-flash font-medium text-white py-2 px-6 rounded"
                    >
                      Delete All
                    </ButtonPrimary>
                  )}
                </div>

                {bookings.length === 0 ? (
                  <div className="flex-colo h-96">
                    <Empty text={"No booking found"} />
                  </div>
                ) : (
                  <TableBooking datas={bookings} dashboard={false} />
                )}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ListingBooking;
